import { PaletteMode, ThemeOptions } from '@mui/material';
import { deepmerge } from '@mui/utils';

import { Settings } from '../context/SettingsContext';

import { createThemeOverrideConfigBreakpoints } from './config/breakpoints';
import { createThemeOverrideConfigPalette } from './config/palette';
import { createThemeOverrideConfigShadows } from './config/shadows';
import { createThemeOverrideConfigSpacing } from './config/spacing';
import { createThemeOverrideConfigTypography } from './config/typography';
import { createThemeOverrideComponentStyles } from './overrides';

export const createThemeOptions = (options: {
  settings: Settings;
  overrideMode: PaletteMode;
  userThemeOptions?: ThemeOptions;
}): ThemeOptions => {
  const { settings, overrideMode, userThemeOptions = {} } = options;

  // =============== VARIABLES
  const {
    skin,
    mode,
    // direction,
    themeColor,
  } = settings;
  const isSemiDark = mode === 'semi-dark';
  const finalMode = isSemiDark ? overrideMode : mode;

  /**
   * Create New object before removing user component overrides
   * and typography objects from userThemeOptions
   */
  const userThemeConfig: ThemeOptions = Object.assign({}, userThemeOptions);
  const mergedThemeConfig: ThemeOptions = deepmerge(
    {
      // direction,
      breakpoints: createThemeOverrideConfigBreakpoints(),
      components: createThemeOverrideComponentStyles(settings),
      palette: createThemeOverrideConfigPalette(finalMode, skin),
      ...createThemeOverrideConfigSpacing(),
      shape: {
        borderRadius: 10,
      },
      mixins: {
        toolbar: {
          minHeight: 64,
        },
      },
      shadows: createThemeOverrideConfigShadows(finalMode),
      typography: createThemeOverrideConfigTypography(),
    },
    userThemeConfig
  );

  // =============== RESULTS
  return deepmerge(mergedThemeConfig, {
    palette: {
      primary: {
        ...(mergedThemeConfig.palette
          ? mergedThemeConfig.palette[themeColor]
          : createThemeOverrideConfigPalette(finalMode, skin).primary),
      },
    },
  });
};

export default createThemeOptions;
